<template>
    <li class="relative">
        <Component
            :is="pin.type === 'item' ? Link : 'a'"
            :href="pin.type === 'item' ? route('web.catalog.products.show', pin.slug) : pin.route"
            :target="pin.type === 'item' ? undefined : '_blank'"
            class="flex gap-4 group items-center max-w-full w-full"
        >
            <!-- Image or Video Icon -->
            <span
                v-if="pin.asset_is_video_resource === 'true'"
                aria-hidden="true"
                class="bg-project-lavender flex items-center justify-center rounded-md shrink-0 size-[60px]"
            >
                <BaseSvg name="PlayCircle" class="size-[30.32px] fill-white" />
            </span>
            <span
                v-else-if="pin.thumbnail"
                aria-hidden="true"
                class="bg-gray-tier-6 flex items-center justify-center rounded-md shrink-0 size-[60px]"
            >
                <img :srcset="useAssetTransforms().assetUrl(pin.thumbnail)" height="45" width="45" alt=""/>
            </span>
            <span
                v-else
                aria-hidden="true"
                class="flex items-center justify-center rounded-md shrink-0 size-[60px]"
                :class="pin.type === 'resource' ? 'bg-project-avocado' : 'bg-gray-tier-6'"
            >
                <BaseSvg
                    :name="pin.type === 'resource' ? 'icon-document' : 'icon-products-outline-thick'"
                    :class="pin.type === 'resource' ? 'fill-white' : 'fill-gray-tier-7'"
                    class="size-[30.32px]"
                />
            </span>

            <!-- Text Content -->
            <span class="flex flex-col overflow-hidden mr-16">
                <span class="flex items-center gap-1">
                    <div 
                        class="mr-1 text-v2-gray-20 underline-offset-4 group-hover:underline dark:text-v2-gray-130 decoration-1"
                        :class="(pin.asset_is_video_resource === 'true' || pin.type === 'resource') ? 'font-medium' : 'font-bold line-clamp-1'"
                        :title="pin.name"
                    >
                        {{ pin.name }}
                    </div>
                    <span
                        v-if="pin.vendor"
                        class="inline-block pb-[3px] px-1.5 pt-0.5 rounded text-[12px] leading-none max-w-40 truncate whitespace-nowrap bg-gray-tier-6"
                        :title="pin.vendor"
                    >
                        <span class="sr-only">from</span>
                        {{ pin.vendor }}
                    </span>
                </span>
                <span v-if="pin.description" aria-hidden="true" class="type-secondary text-sm truncate line-clamp-1" :title="pin.description">
                    {{ pin.description }}
                </span>
            </span>
        </Component>
<!--        More Menu-->
        <div v-click-outside="closeMenu" class="absolute right-2 top-3.5">
            <PinItemDropdownMenu :pin="pin" :toggle-more="toggleMore" :is-more-open="isMoreOpen"/>
        </div>
    </li>
</template>

<script setup>
import {ref, onMounted, onUnmounted} from 'vue';
import {BaseSvg, PinItemDropdownMenu} from '@/Components';
import {useAssetTransforms, eventBus} from "@/Composables";
import {Link} from "@inertiajs/vue3";

const props = defineProps({
    pin: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['move-to', 'add-to', 'remove-pin', 'copy-link']);

const isMoreOpen = ref(false);
const isMoveOpen = ref(false);
const isAddOpen = ref(false);

function toggleMore() {
    isMoreOpen.value = !isMoreOpen.value;
    if (!isMoreOpen.value) {
        isMoveOpen.value = false;
        isAddOpen.value = false;
    }
}

const closeMenu = () => {
    isMoreOpen.value = false;
}

// onMounted(() => {
//     eventBus.on('pins:dialog-scrolled', closeMenu);
// });

// onUnmounted(() => {
//     eventBus.off('pins:dialog-scrolled', closeMenu);
// });
</script>
